import React, { useState, useEffect } from "react";
import { useNavigate } from 'react-router-dom';
import apiClient from "@/api/client";
import imageOne from '../../resource/community/dhammaSermons/2.png';
import imageTwo from '../../resource/community/dhammaSermons/3.png';
import imageThree from '../../resource/community/dhammaSermons/1.png';
import imageFour from '../../resource/community/dhammaSermons/4.png';
import TitleChange from "../../Hook/TitleChnage";
import BookingCalendar from "../Calendar/BookingCalendar";

const DhammaSermons = () => {
    TitleChange("Paritta at Home");

    const navigate = useNavigate();
    const [bookedDates, setBookedDates] = useState([]);
    const [blockedDates, setBlockedDates] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchSermonDates = async () => {
            try {
                const response = await apiClient.get('/get-sermon-requests');
                const data = response.data;

                // Adjust the following lines based on your API response structure
                // Example structure: { booked: [...], blocked: [...] }
                setBookedDates(data.booked || []);
                setBlockedDates(data.blocked || []);
            } catch (error) {
                console.error("Failed to fetch sermon dates:", error);
            } finally {
                setLoading(false);
            }
        };

        fetchSermonDates();
    }, []);

    const handleClick = (event) => {
        const pathMap = {
            housepreparation: '/housepreparation',
            dammaSermonsRequest: '/dammaSermonsRequest'
        };
        const path = event.currentTarget.id;
        const targetPath = pathMap[path];
        if (targetPath) {
            navigate(targetPath);
        }
    };

    if (loading) {
        return (
            <div className="paritta-page inside-pages">
                <div className="right-box">
                    <img src={imageOne} alt="Right Top Image" className="right-image" width={300} />
                </div>
                <div className="text-center p-4">
                    <h1 className="font-main dark-gold p-4">Loading calendar data...</h1>
                </div>
            </div>
        );
    }

    return (
        <div className="paritta-page inside-pages">
            <div className="right-box">
                <img src={imageOne} alt="Right Top Image" className="right-image" width={300} />
            </div>

            <h1 className="font-main p-4">Dhamma Sermons at Home</h1>

            <p className="h4 p-4 mt-5 ">
                In the Buddhist tradition, inviting a Sangha member to deliver a Dhamma sermon at home is a cherished and meaningful event, often shared with relatives and friends. This practice provides an opportunity to deepen one’s understanding of the Dhamma, cultivate virtuous qualities, and learn beneficial practices for people of all ages.
            </p>
            <p className="h4 p-4 mt-5 ">
                Dhamma Dana, the act of offering teachings, is regarded as the highest form of generosity (Dana) in Buddhism. It is a special way to contribute to the spread of the Dhamma, benefiting both the giver and the receiver. Hosting a Dhamma talk offers a precious opportunity to gain wisdom while fostering goodwill and positive energy among loved ones.
            </p>
            <p className="h4 p-4 mt-5">
                Such sermons are often held on special occasions, such as moving to a new home, starting a new job, or celebrating a birthday. It is customary to invite relatives and friends to join in these teachings, as it helps to collectively accumulate merits and share them with departed loved ones.
            </p>
            <p className="h4 p-4 mt-5">
                To arrange a Dhamma sermon at home, please refer to the Dhamma Sermons Calendar for available dates.
            </p>

            <div className="calander-box">
                <div className="calnder mt-5">
                    <BookingCalendar
                        bookedDates={bookedDates}
                        blockedDates={blockedDates}
                        filterType="all"
                        showRefreshButton={true}
                        onRefresh={async () => {
                            const res = await apiClient.get('/get-sermon-requests');
                            const data = res.data;
                            setBookedDates(data.booked || []);
                            setBlockedDates(data.blocked || []);
                        }}
                    />
                </div>
            </div>

            <p className="h4 p-4 mt-5 ">
                The video will also help you understand the process by which the Dhamma Sermon is performed at home.
            </p>

            <div className="btn-group mt-6">
                <img
                    src={imageFour}
                    alt="Right Top Image"
                    width={300}
                    onClick={handleClick}
                    id="housepreparation"
                    className="curser-pointer"
                />
            </div>

            <div className="mt-6 calander-box align-item-center p-4 text-center">
                <div className="c-details text-left">
                    <h2 className="intro-text ">Contact Details</h2>
                    <p className="font-p mt-4">Monastery : 035608 0918 / 0459 729 738</p>
                    <p className="font-p">Mr Gamini : 0422 069 359</p>
                    <p className="font-p">WhatsApp : 0422 069 359</p>
                    <p className="font-p">E-mail : info@bvp.org.au</p>
                </div>
                <div className="d-button">
                    <img
                        src={imageTwo}
                        alt="Right Top Image"
                        className="right-image curser-pointer"
                        width={300}
                        id="dammaSermonsRequest"
                        onClick={handleClick}
                    />
                </div>
            </div>

            <div className="bottom-box mt-5">
                <img src={imageThree} alt="bottom-image" width={600} />
            </div>
        </div>
    );
};

export default DhammaSermons;